import { createReducer, on } from "@ngrx/store";
import { DEFINICJA_WIDOKOW_MAPY, WIDOKI_MAPY_ID } from "./mapa-widok.const";
import { MapaWidokActions } from "./mapa-widok.actions";

export interface WidokiMapy {
  id: string,
  desktop: boolean,
  mobile: boolean
}


export const WidokiMapyInitialState: WidokiMapyState = {
  widokMapyId: WIDOKI_MAPY_ID.WIDOK_MAPY,
  dane: undefined,
  daneInicjujacePasekCzasu: undefined,
  aktywneNarzedzie: undefined
}

export interface WidokiMapyState {
  widokMapyId: string,
  dane?: any,
  daneInicjujacePasekCzasu?: any;
  aktywneNarzedzie?: string;
}

export const mapaWidokReducer = createReducer(
  WidokiMapyInitialState,
  on(MapaWidokActions.uruchomMapaWidok, (state, { widokMapyId }) => state = { ...state, widokMapyId: DEFINICJA_WIDOKOW_MAPY.get(widokMapyId)!.id }),
  on(MapaWidokActions.zamknijMapaWidok, (state, { widokMapyId }) => state = { ...state, widokMapyId: DEFINICJA_WIDOKOW_MAPY.get(widokMapyId)!.id }),
  on(MapaWidokActions.aktualizujDane, (state, { widokMapyId, dane }) => state = { ...state, widokMapyId: DEFINICJA_WIDOKOW_MAPY.get(widokMapyId)!.id, dane: dane }),
  on(MapaWidokActions.zapiszGrupePaskaCzasu, (state, { widokMapyId, daneInicjujacePasekCzasu }) => state = { ...state, widokMapyId: DEFINICJA_WIDOKOW_MAPY.get(widokMapyId)!.id, daneInicjujacePasekCzasu: daneInicjujacePasekCzasu }),
  on(MapaWidokActions.ustawAktywneNarzedzie, (state, { narzedzieId }) => ({
    ...state,
    aktywneNarzedzie: narzedzieId
  })),
  on(MapaWidokActions.wyczyscAktywneNarzedzie, (state) => ({
    ...state,
    aktywneNarzedzie: undefined
  })),
  on(MapaWidokActions.reset, (state) => {
    return WidokiMapyInitialState
  })
)
